import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-show-text-dialog',
    templateUrl: './show-text-dialog.component.html',
    standalone: false
})
export class ShowTextDialog {

  title: string = '';
  text: string = '';
  close: string = '';

  constructor(public dialogRef: MatDialogRef<ShowTextDialog>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.text = data.text;
    this.close = data.close;
  }


}
